module.exports = __webpack_public_path__ + "static/media/wm-slogan-integration.4732729f.jpg";